import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["submitButton"]

  static values = {
    originalLanguages: Array,
    confirmTitle: String,
    confirmMessage: String
  }

  connect() {
    this._confirmed = false;
    this._cancelHandler = () => { this._confirmed = false; };

    document.addEventListener('promote:confirm-cancel', this._cancelHandler);
  }

  disconnect() {
    document.removeEventListener('promote:confirm-cancel', this._cancelHandler);
  }

  submit(event) {
    if (this._confirmed) {
      this._confirmed = false;

      return;
    }

    const selectedLanguages = this._selectedLanguages();
    const removedLanguages = this.originalLanguagesValue
      .filter(lang => !selectedLanguages.includes(lang));

    if (removedLanguages.length === 0) return;

    event.preventDefault();

    this._confirmed = true;

    const langNames = removedLanguages
      .map(code => this._languageName(code))
      .join(', ');

    const message = this.confirmMessageValue.replace('%{languages}', `<strong>${langNames}</strong>`);

    Rails.confirm(
      message,
      this.submitButtonTarget,
      { confirmTitle: this.confirmTitleValue, confirmError: 'true' }
    );
  }

  _selectedLanguages() {
    const hiddenFields = this.element.querySelectorAll(
      '[data-components--admin-dropdowns-dropdown-target="hiddenField"]'
    );

    return Array.from(hiddenFields)
      .map(field => field.value)
      .filter(value => value.length > 0);
  }

  _languageName(code) {
    const item = this.element.querySelector(`.admin-dropdown-item[data-value="${code}"]`);

    return item ? item.textContent.trim() : code;
  }
}
